import { notification } from 'antd';
import { useState } from 'react';
import type { SubmitHandler, UseFormTrigger } from 'react-hook-form';
import { useNavigate } from 'react-router';

import { ieLeasingApi } from '@/components/App/Leasing/api';
import { ieLeasingFormMapper } from '@/components/App/Leasing/helpers';
import type { TIeForm } from '@/components/App/Leasing/types';
import { ROUTES } from '@/components/Shared/routes/routes';
import { handleError } from '@/services/handleError';
import { useAppSelector } from '@/store';

import { useLeasingRequestId } from '../../../hooks';
import { getLeasingDraftKey } from '../../helpers';
import { REQUIRED_FIELDS } from '../constants';

interface IProps {
  currentStep: number;
  setCurrentStep: (step: number) => void;
  trigger: UseFormTrigger<TIeForm>;
}

const useIeLeasingCreate = ({
  currentStep,
  setCurrentStep,
  trigger
}: IProps) => {
  const navigate = useNavigate();

  const { request } = useAppSelector((state) => state.ieLeasingOrder);

  const { requestId } = useLeasingRequestId();

  const [isCreateLoading, setIsCreateLoading] = useState(false);

  const onSubmit: SubmitHandler<TIeForm> = async (values) => {
    const isValid = await trigger(REQUIRED_FIELDS[currentStep]);
    if (!isValid || !request) return;

    if (values.subjects.length === 0) {
      notification.error({
        title: 'Необходимо добавить хотя бы одну модель автомобиля'
      });
      return;
    }

    if (currentStep < 2) {
      setCurrentStep(currentStep + 1);
      return;
    }

    setIsCreateLoading(true);
    try {
      const { requestUuid } = await ieLeasingApi.create(
        ieLeasingFormMapper.toCreateDto(values, request)
      );

      sessionStorage.removeItem(getLeasingDraftKey(requestId));

      navigate(ROUTES.leasingIeRequest(requestUuid));
    } catch (error) {
      handleError(error);
    }

    setIsCreateLoading(false);
  };

  return { isCreateLoading, onSubmit };
};

export default useIeLeasingCreate;
